import { computed, ref } from "vue";
import { defineStore } from "pinia";
import { useDisplay } from "vuetify";

import { SETTINGS } from "@/utils/constants";
import { ICommunityFactorySchema } from "@/utils/types";

export const useAppStore = defineStore(
  "app",
  () => {
    const { width } = useDisplay();

    const darkMode = ref(true);
    const language = ref<string>(SETTINGS.languages[0] || "en");
    const activeFactorySchema = ref<ICommunityFactorySchema>();
    const isSdkInitialized = ref(false);

    const isMobile = computed(() => width.value < 1024);

    function toggleDarkMode() {
      darkMode.value = !darkMode.value;
    }

    function setActiveLanguage(lang: string) {
      language.value = lang;
    }

    return {
      darkMode,
      language,
      toggleDarkMode,
      setActiveLanguage,
      activeFactorySchema,
      isSdkInitialized,
      isMobile,
    };
  },
  { persist: true }
);
